import React from 'react';
import MenuBarContainer from '@bvt-features/mainmap/menu-bar/container/MenuBarContainer';
import ModuleBarContainer from '@bvt-features/mainmap/module-bar/container/ModuleBarContainer';
import {
  GeoJsonMapAdvanceSearch,
  MapSearch,
  MapSearchBoundingMap,
} from '@bvt-features/mainmap/place/component/MapAdvancedSearch';
import { MapContainer } from 'react-leaflet';
import 'leaflet-arrowheads';
import 'leaflet/dist/leaflet.css';
import SiproMapContainer from '@bvt-features/mapana/sipro/container/SiproMapContainer';
import { DEFAULT_MAP_OPTIONS_DATA_CONSTANT } from '@bvt-features/mainmap/mainmap/constant/DEFAULT_MAP_OPTIONS_DATA_CONSTANT';
import { GrianaMapContainer } from '@bvt-features/mapana/griana/container/GrianaMapContainer';
import { MainMapToolbarContainer } from '../MainMapToolbarContainer';
import { MainMapTileLayerContainer } from '../MainMapTileLayerContainer';
import { MainMapLayeringVisiblityAndBasemapContainer } from '../MainMapLayeringVisiblityAndBasemapContainer';
import { DatexContainer } from '@bvt-features/datex/container/DatexContainer/DatexContainer';
import DroppableMarker from '@bvt-features/mainmap/droppable-marker/component/DroppableMarker';
import { LegendContainer } from '@bvt-features/mainmap/legend/container/LegendContainer';
import { PoiSearchMarkerContainer } from '@bvt-features/mainmap/poi-search/container';
import { PertaminaDetailContainer } from '@bvt-features/pertamina/container/PertaminaDetailContainer';
import { PertaminaMarkerGeojsonContainer } from '@bvt-features/pertamina/container/PertaminaMarkerGeojsonContainer';
import { PertaminaLegendContainer } from '@bvt-features/pertamina/container/PertaminaLegendContainer';
import { PertaminaDroppableMarker } from '@bvt-features/pertamina/container/PertaminaDroppableMarker';
import { PertaminaDownloadNotificationContainer } from '@bvt-features/pertamina/container/PertaminaDownloadNotificationContainer';
import { PertaminaGrianaContainer } from '@bvt-features/pertamina/container/PertaminaGrianaContainer';
import { DanoneLegendContainer } from '@bvt-features/danone/legend/container/DanoneLegendContainer/DanoneLegendContainer';
import { DanonePoiCollectionContainer } from '@bvt-features/danone/area-profiling/container/DanonePoiCollectionContainer';
import { DanonePolygonContainer } from '@bvt-features/danone/area-profiling/container/DanonePolygonContainer';
import { DanoneDroppableMarker } from '@bvt-features/danone/area-profiling/container/DanoneDroppableMarker';
import { DanoneTerritoryGeojson } from '@bvt-features/danone/territory-planning/container/DanoneTerritoryGeojson';
import { TSAMarkerGeojsonContainer } from '@bvt-features/tenant-suitability/container/TSAMarkerGeojsonContainer';
import { TSADetailContainer } from '@bvt-features/tenant-suitability/container/TSADetailContainer';
import { TSALegendContainer } from '@bvt-features/tenant-suitability/container/TSALegendContainer';
import { TSADroppableMarker } from '@bvt-features/tenant-suitability/container/TSADroppableMarker';
import { TSADownloadNotificationContainer } from '@bvt-features/tenant-suitability/container/TSADownloadNotificationContainer';
/**
 * @author Randa<m.randa@bvarta.com>
 * @description New Base map all feature register in this component;
 * @param {object} props
 * @param {JSX.Element} props.children
 * @returns {JSX.Element}
 */
export const LayoutMainMapContainer = (props) => {
  const { children } = props;

  return (
    <React.Fragment>
      <MapContainer {...DEFAULT_MAP_OPTIONS_DATA_CONSTANT}>
        <MainMapTileLayerContainer />
        <MenuBarContainer />
        <ModuleBarContainer />
        <MapSearch />
        <PoiSearchMarkerContainer />
        <LegendContainer />
        <MainMapToolbarContainer />
        <MainMapLayeringVisiblityAndBasemapContainer />
        <GeoJsonMapAdvanceSearch />
        <MapSearchBoundingMap/>
        {/* START FEATURE */}
        <DatexContainer />
        <GrianaMapContainer />
        <SiproMapContainer />
        <DroppableMarker />
        <PertaminaDetailContainer />
        <PertaminaMarkerGeojsonContainer />
        <PertaminaLegendContainer />
        <PertaminaDroppableMarker />
        <PertaminaDownloadNotificationContainer />
        <PertaminaGrianaContainer />
        <DanoneLegendContainer />
        <DanonePoiCollectionContainer />
        <DanonePolygonContainer />
        <DanoneDroppableMarker />
        <DanoneTerritoryGeojson />

        <TSADetailContainer />
        <TSAMarkerGeojsonContainer />
        <TSALegendContainer />
        <TSADroppableMarker />
        <TSADownloadNotificationContainer />
        {/* END FEATURE */}
      </MapContainer>
      <div>
        {/*
          for sidebar MAPANA,
          if you need interact with map,
          please create another component and put to inside of MapContainer,
          use redux and useeffect to trigger your function
        */}
        {children}
      </div>
    </React.Fragment>
  );
};
